<!-- Error State -->
@if (error && !isLoading) {
  <div class="quiz-page">
    <div class="quiz-container quiz-container--error">
      <p class="error-message">{{ error }}</p>
    </div>
  </div>
}

<!-- Quiz Content with Course Layout -->
@if (!isLoading && !error && courseTrack) {
  <div class="quiz-page">
    <!-- Header with breadcrumb and progress -->
    <ut-academy-header
      [title]="headerTitle"
      [showProgress]="isPartOfLearningTrack"
      [currentProgress]="trackCoursesCompleted"
      [totalItems]="trackCoursesTotal"
      (backClick)="onBackToTracks()">
    </ut-academy-header>
    @if (isLockedByOrder) {
      <ut-academy-course-locked [learningTrackName]="courseTrack.learning_track_name"></ut-academy-course-locked>
    } @else {
    <!-- Main Content Area: Quiz + Sidebar -->
    <div class="quiz-layout">
      <!-- Left: Quiz Content -->
      <section class="quiz-main" aria-label="Quiz content">
        <div class="quiz-container">
          <!-- Header -->
          <div class="quiz-container-header">
            <h2 class="quiz-container-title">Quiz: {{ courseTrack.name }}</h2>
            <p class="quiz-container-subtitle">
              Test your knowledge with this quiz to complete the course.
            </p>
          </div>
          <hr class="quiz-container-divider">
          <!-- Question Content -->
          <div class="quiz-container-content">
            <!-- Progress Indicator -->
            <ut-academy-quiz-progress
              [currentQuestion]="currentQuestionNumber"
              [totalQuestions]="totalQuestions"
            ></ut-academy-quiz-progress>
            <!-- Current Question -->
            @if (currentQuestion) {
              <div class="quiz-container-question">
                <ut-academy-quiz-question
                  [question]="currentQuestion"
                  [selectedChoiceId]="selectedChoiceId"
                  (answerSelected)="onAnswerSelected($event)"
                ></ut-academy-quiz-question>
              </div>
            }
          </div>
          <!-- Navigation -->
          <div class="quiz-container-navigation">
            <button
              type="button"
              class="quiz-nav-btn secondary"
              [disabled]="isFirstQuestion"
              (click)="goToPrevious()"
              >
              <svg class="quiz-nav-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                <path d="M15.8333 9.99984H4.16663M4.16663 9.99984L9.99996 15.8332M4.16663 9.99984L9.99996 4.1665" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Previous
            </button>
            @if (!isLastQuestion) {
              <button
                type="button"
                class="quiz-nav-btn primary"
                [disabled]="!canContinue"
                (click)="goToNext()"
                >
                Continue
                <svg class="quiz-nav-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                  <path d="M4.16663 9.99984H15.8333M15.8333 9.99984L9.99996 4.1665M15.8333 9.99984L9.99996 15.8332" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            }
            @if (isLastQuestion) {
              <button
                type="button"
                class="quiz-nav-btn primary"
                [disabled]="!canContinue || isSubmitting"
                (click)="submitQuiz()"
                >
                {{ isSubmitting ? 'Submitting...' : 'Submit' }}
                <svg class="quiz-nav-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                  <path d="M4.16663 9.99984H15.8333M15.8333 9.99984L9.99996 4.1665M15.8333 9.99984L9.99996 15.8332" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            }
          </div>
        </div>
      </section>
      <!-- Right: Course Content Sidebar -->
      <aside class="quiz-sidebar" aria-label="Course information">
        <ut-course-content-sidebar
          [courseTrack]="courseTrack"
          [currentLessonId]="null"
          [quizActive]="true"
          (lessonClick)="onLessonClick($event)">
        </ut-course-content-sidebar>
      </aside>
    </div>
    }
  </div>
}
